export default function checkLogin() {
  return (
    localStorage.getItem('token') !== '' &&
    localStorage.getItem('token') !== null
  );
}
